import moment from 'moment';

export const createdBy = (user) => {
  return user ? `${user.firstName} ${user.lastName}` : this.$t('@campaignsList/customer');
};

export const serializeQuery = (query = {}) =>
  Object.keys(query)
    .map((k) => {
      if (Array.isArray(query[k])) {
        return query[k].map((el) => `${encodeURIComponent(k)}=${encodeURIComponent(el)}`).join('&');
      }
      return `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`;
    })
    .join('&');

const dateFormatter = (format, date) => {
  if (!date) {
    return 'n/a';
  }
  return moment(date).format(format);
};

export function onKeyPress(e, onlyNumbers) {
  const event = e || window.event;
  const charCode = typeof e.which === 'undefined' ? event.keyCode : event.which;
  const charStr = String.fromCharCode(charCode);
  if (!charStr.match(/^[0-9-]+$/)) {
    e.preventDefault();
  }

  if (onlyNumbers && !charStr.match(/^[0-9]+$/)) {
    e.preventDefault();
  }
}

// thousands separators
export function numberWithThousandsSeparators(number, separator = ',') {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}

export function mergeById(a1, a2) {
  if (!a1 || !a2) {
    return;
  }

  return a1.map((itm) => ({
    ...a2.find((item) => item.name === itm.name && item),
    ...itm,
  }));
}

export const defaultDateTimeFormatter = (value) => dateFormatter('DD MMM YYYY, HH:mm:ss', value);
export const defaultDateFormatter = (value) => dateFormatter('DD MMM YYYY', value);
export const defaultCostFormatter = (value) => Math.round(value);
export const monthDateFormatter = (value) => dateFormatter('MMM YYYY', value);
export const isoDateFormatter = (value) => dateFormatter('YYYY-MM-DD', value);

// eslint-disable-next-line
export const emailRegexp = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
export const phoneRegexp = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3}|[0-9]{4})$/;
export const phonePrefixHardcode = '+46';

export const emojiRegex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
// eslint-disable-next-line
export const textRegex = /^[a-zA-ZÅÀÂÃÁĀÄàáâäãåāöŌōÖ0-9!.,()*\/\|\\%^& $%*<>?,'"_;{}+:=@-]{0,255}$/;

export function navigateLoginUrl(returnUrl) {
  const baseUrl = process.env.VUE_APP_AUTHENTICATION_SERVICE_URL;
  const loginUrl = `${baseUrl}/login.html`.replace(/(https?:\/\/)|(\/){2,}/g, '$1$2');

  const redirectUrl = encodeURIComponent(returnUrl || window.location.href);
  const loginUrlWithRedirect = `${loginUrl}?redirecturl=${redirectUrl}`;

  window.location.assign(loginUrlWithRedirect);
}
